import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SiteTicker from "@/components/SiteTicker";
import CookieBanner from "@/components/CookieBanner";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-navy flex flex-col">
      <Navbar />
      <main className="flex-1 pt-20"><SiteTicker />{children}</main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
